// frontend/src/pages/admin/ContactsView.js

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API_URL } from '../../config';

function ContactsView() {
    const [contacts, setContacts] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            navigate('/admin/login');
            return;
        }

        fetch(`${API_URL}/api/contacts`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (!res.ok) throw new Error('Not authorized');
            return res.json();
        })
        .then(data => setContacts(data))
        .catch(err => {
            console.error("Failed to fetch contacts:", err);
            navigate('/admin/login');
        });
    }, [navigate]);

    // --- פונקציה חדשה למחיקה ---
    const handleDelete = async (contactId) => {
        if (!window.confirm('האם אתה בטוח שברצונך למחוק פנייה זו?')) {
            return;
        }

        const token = localStorage.getItem('accessToken');
        try {
            const response = await fetch(`${API_URL}/api/contacts/${contactId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                // הסרת הפנייה מהמערך המקומי כדי לעדכן את התצוגה בלי לרענן
                setContacts(prevContacts => prevContacts.filter(contact => contact.id !== contactId));
            } else {
                alert('מחיקת הפנייה נכשלה.');
            }
        } catch (err) {
            console.error("Failed to delete contact:", err);
            alert('אירעה שגיאת רשת.');
        }
    };

    return (
        <div id="main">
            <section className="post">
                <header className="major" style={{textAlign: 'center'}}>
                    <h1>מערכת ניהול - פניות שהתקבלו</h1>
                </header>
                <div className="admin-toolbar">
                    <Link to="/admin/projects" className="button primary">לניהול הפרויקטים</Link>
                </div>
                <div className="contacts-list">
                    {contacts.length > 0 ? contacts.map(contact => (
                        <div key={contact.id} className="contact-card">
                            {/* --- הוספת כפתור המחיקה --- */}
                            <button onClick={() => handleDelete(contact.id)} className="delete-btn" title="מחק פנייה">×</button>
                            <h4>{contact.name} - <a href={`mailto:${contact.email}`}>{contact.email}</a></h4>
                            {contact.phone && <p><strong>טלפון:</strong> {contact.phone}</p>}
                            <p>{contact.message}</p>
                            <small>{new Date(contact.timestamp).toLocaleString('he-IL')}</small>
                        </div>
                    )) : <p style={{textAlign: 'center'}}>אין פניות חדשות.</p>}
                </div>
            </section>
        </div>
    );
}
export default ContactsView;